<template>
  <div class="wx-news-message">
    <div class="content">
      <div>
        <!--卡片选择新闻-->
        <el-card class="box-card" style="margin-top: 50px">
          <div slot="header" class="clearfix">
            <span>卡片名称</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="addNew"
            >新增新闻</el-button
            >
          </div>
          <div class="text item">
            <ul
              infinite-scroll-disabled="disabled"
              infinite-scroll-delay="200"
              class="infinite-list"
              style="overflow: auto; max-height: 200px"
            >
              <li
                v-for="i in newsList"
                :key="i.msgno"
                class="infinite-list-item"
                @click="choose(i)"
              >
                {{ i.first }}
              </li>
            </ul>
          </div>
        </el-card>
      </div>
      <div>
        <el-form
          v-loading="saveLoing"
          ref="ruleForm"
          :model="form"
          label-width="80px"
          class="form"
        >
          <el-form-item label="标题">
            <el-input v-model="form.first"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <editoritem :value.sync="form.remark" @change="changValue"></editoritem>
          </el-form-item>
        </el-form>
        <el-button v-if="!saveLoing" type="primary" @click="save">保存</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import Editoritem from '../Form/Editoritem'
import HomeApi from '../../network/home'
export default {
  components: {
    Editoritem
  },
  name: 'wxNewsMessage',
  data() {
    return {
      form: {
        first: '',
        remark: ''
      },
      newsList: [],
      saveLoing: false
    }
  },
  created() {
    this.getNew()
  },
  methods: {
    async getNew() {
      const result = await HomeApi.getAllWxNew()
      this.newsList = result
    },
    changValue(value) {
      this.form.remark = value
    },
    async save() {
      this.saveLoing = true
      try {
        const result = await HomeApi.addNew(this.form)
        if (result == '成功') {
          this.$message.success(result)
        } else {
          this.$message.error(result)
        }
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.form = {}
        this.saveLoing = false
      }
    },
    addNew() {

    },
    choose(i) {
      this.form = i
    }
  }
}
</script>

<style scoped>
  .content {
    display: flex;
    justify-content: space-evenly;
  }
</style>
